/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_2_1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_2_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_2_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial legacy import; save the result as .xlsx and inspect styles and objects.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_2_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_2_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分支持旧格式导入；将结果保存为 .xlsx，并检查样式和对象。`)
};

/**
* | output |
* | --- |
* | "Partial legacy import; save the result as .xlsx and inspect styles and objects." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_2_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_2_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_2_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_2_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_2_1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_2_1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_2_1 as "gc.search_guides.gridcraft_excel_compatibility.sections.3.table.rows.2.1" }